"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var Carousel_1=require("./Carousel");exports.default=Carousel_1.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-multi-carousel/lib/index.js
// module id = 824
// module chunks = 10 11